import { useGSAP } from '@gsap/react';
import ButtonFill from '../ui/ButtonFill';
import Checkbox from '../ui/Checkbox';

import Image from 'next/image';
import gsap from 'gsap';
import { useRef, useState } from 'react';

const AboutCareer = ({ text, title, textAfter, btnText, btnLink, textRight, textRightSmall, image, sign1, sign2 }) => {

  const sectionRef=useRef(null)
  const titleRef=useRef(null)
  const textRef=useRef(null)
  const subTextRef =useRef(null)
  const buttonRef = useRef(null)
  const imageWrapperRef=useRef(null)
  const rightText = useRef(null)
  // const signsWrapper = useRef(null)
  const imageRef = useRef(null)
  const containerRef = useRef(null)

  const [checked, setChecked] = useState(false);


  useGSAP(()=> {


    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {

      gsap.fromTo(containerRef.current, {
        y: '15rem'
      },
          {
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom", 
          end: "top 55%",  
          scrub: 0.1,  
        },
      });

      gsap.fromTo(titleRef.current, { opacity: 0, y: '8rem' }, {
        opacity: 1,
        y: 0,
        duration: 1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 40%",
        },
      });

      gsap.fromTo(textRef.current, { opacity: 0, y: '6rem'}, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.2,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 40%",
        },
      });
      
      gsap.fromTo(subTextRef.current, { opacity: 0, y: '4rem'}, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.3,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 40%",
        },
      });


      gsap.fromTo(buttonRef.current, { opacity: 0, y: '4rem'}, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.4,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 40%",
        },
      });

      gsap.fromTo(rightText.current, { opacity: 0, y: '8rem'}, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 40%",
        },
      });

      // gsap.fromTo(signsWrapper.current, { opacity: 0, y: '6rem'}, {
      //   opacity: 1,
      //   y: 0,
      //   duration: 1,
      //   delay: 0.3,
      //   scrollTrigger: {
      //     trigger: sectionRef.current,
      //     start: "top 40%",
      //   },
      // });

      

      gsap.fromTo(imageRef.current, 
          { y: "-2rem" }, 
          {
            y: "5rem",
            ease: "none",
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "center bottom",
              end: "center top",
              scrub: 0.1,
            }
          }
        )})

  }, {scope: sectionRef});

  return (
    <section ref={sectionRef} className="container-max py-[4rem] md:py-[6rem] lg:py-[7rem] xl:py-[8rem] container-padding">
      <div className='flex-col container-grid' ref={containerRef}>

      <div className='w-full md:col-span-5 lg:col-span-3 xl:mb-[4rem] md:mb-[4rem] lg:mb-0 lg:flex lg:flex-col lg:justify-start lg:pt-[18rem]'>
        <h2 ref={titleRef} className="w-full text-dark-blue  mb-[2rem] lg:mb-[4rem] md:mb-[2.4rem] ">{title}</h2>

        <p ref={textRef} className='text-1 mb-[2.8rem] md:mb-0 max-w-[46rem]'>{textRightSmall}</p>


      </div>


      <div className="md:col-span-2 relative w-full mb-[2.4rem] overflow-hidden lg:col-span-4 lg:col-start-5 flex items-center justify-center md:mb-0 aspect-[0.8375/1]">
        <div ref={imageWrapperRef} className='h-[100%] lg:h-[105%] overflow-hidden flex items-center justify-center w-full relative'>
          <div ref={imageRef} className='relative w-full h-[105%] '>
            <Image
              src={image.url}
              alt={image?.alt}
              fill
              sizes="(max-width: 768px) 100vw, 50vw"

              className="w-auto object-cover"
            />
          </div>

        </div>
          
        </div>
      <div className='w-full relative md:flex md:items-end md:col-start-4  lg:col-span-3 lg:flex lg:flex-col lg:justify-start lg:pt-[18rem] lg:col-start-10 md:col-span-2'>
          <div ref={rightText} className='w-full'>
            {/* <h3  className='heading-4 mb-[1.6rem] xl:mb-[2.8rem]'>{textRight}</h3> */}

        <div className="mb-[2.8rem] lg:mb-0 w-full lg:mb-[3.2rem] xl:mb-[4rem] md:mb-0">
          <div  className="md:max-w-[48rem] w-full lg:max-w-none mb-[2rem] xl:mb-[4rem] md:mb-[2.4rem] lg:mb-[3.2rem] text-dark-blue flex flex-col gap-[1.6rem]">
            {text.map((paragraph, index) => (
              <p className="text-1 " key={index}>
                {paragraph.text}
              </p>
            ))}
          </div>

          <div className={'w-full flex md:flex-col md:justify-between md:items-start flex-col lg:flex-col lg:items-start'}>
          <div className='md:mb-[4rem] w-full mb-[2.4rem] flex items-start gap-[1.2rem] lg:w-full md:mb-0 lg:mb-[2.4rem] xl:mb-[4rem] md:gap-[1.6rem]'>
            
            <Checkbox 
              checked={checked} 
              onChange={setChecked} 
            />

            <p
              ref={subTextRef}
              onClick={(e) => {
                if (!e.target.closest('a')) {
                  setChecked(!checked);
                }
              }}
              className="caption cursor-pointer select-none md:w-[41.8rem] [&>a]:duration-300 [&>a]:underline [&>a]:transition-opacity [&>a]:hover:opacity-80 [&>a]:text-dusty-green-dark"
              dangerouslySetInnerHTML={{ __html: textAfter }}
            />
            
          </div>

            <div ref={buttonRef} className=''>
              <ButtonFill isLink={true} href={btnLink} disabled={!checked} className='md:w-fit text-nowrap'>
                {btnText}
                <img className="ml-[1.2rem] -rotate-45" loading='lazy' fetchPriority='low' src="/images/arrow_right.svg" alt="Стрелка вправо" />
              </ButtonFill>
            </div>

          </div>
        </div>

          </div>
          {/* <div ref={signsWrapper} className='md:flex flex-col hidden -rotate-[0deg] absolute top-[2rem]  left-[-12rem]  md:top-0 lg:top-auto lg:bottom-[-3rem] xl:bottom-[0rem] gap-[0.5rem] '>
            <div className='h-[8rem] w-[16rem] lg:top-[1rem] md:w-[22rem] md:h-[12rem] lg:left-[4rem] lg:h-[14rem] lg:w-[24rem] relative'>
                      <Image
                      src={sign1.url}
                      alt=""
                      fill
                      sizes="300px"
                      className="w-auto object-cover"
                    />
            </div>

            <div className='h-[8rem] md:top-[-4rem]  lg:top-[-2rem] lg:h-[10rem] lg:w-[22rem] w-[16rem] md:w-[18rem] md:h-[8rem] lg:left-[-5rem] md:left-[-3rem] relative'>
                      <Image
                      src={sign2?.url}
                      alt=""
                      fill
                      sizes="300px"
                      className="w-auto object-cover"
                    />
            </div>
          </div> */}
      </div>
      
      </div>
    </section>
  );
};

export default AboutCareer;